import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { useJDQuery } from "../api/queries";
import { JDFilter } from "../ui/JDFilter";
import { JDTable } from "../ui/JDTable";
import { JDToolbar } from "../ui/JDToolbar";

export function JDListPage() {
  const nav = useNavigate({ from: "/app/jd" });
  const search: OffsetPageQueryDTO = useSearch({ from: "/app/jd" });

  const list = useJDQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["jd:create"]);

  return (
    <>
      <Header />

      <Main>
        <JDToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/jd/new" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <JDFilter />

          <JDTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(jd) => nav({ to: `/app/jd/${jd.id}/edit` })}
            onView={(jd) => nav({ to: `/app/jd/${jd.id}` })}
          />
        </div>
      </Main>
    </>
  );
}
